import React from 'react';
import style from './ProductBrandProductList.scss';
import { ProductList } from './ProductList.js';
export const ProductBrandProductList = ({ products }) => (products === null || products === void 0 ? void 0 : products.length) ? (React.createElement(ProductList, { className: style.productList, products: products, cardsPerRow: 3, twoColumnsTabletView: true })) : (React.createElement("p", null, "Tuotemerkille ei l\u00F6ytynyt tuotteita"));
